import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { externalProductPestPacName } from '@sales-center/common'

export const useGetBillToLocationUrl = (
  billToLocationId: string | undefined,
  serviceLocationId?: string | undefined,
) => {
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  if (!billToLocationId) return ''

  switch (externalProduct) {
    case externalProductPestPacName:
      return `${clientUrl}/billto/edit.asp?Mode=Edit&BillToID=${billToLocationId}${
        serviceLocationId ? `LocationID=${serviceLocationId}` : ''
      }`
    default:
      return ''
  }
}
